import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  modulesListRequest,
  modulesListSuccess,
  modulesListFailure,
} from '../reducers/modulesList';
import { authUserFailure } from '../reducers/login';
import { API_LINK } from '../../constants';
import { getUserRolloutFailure, getUserRolloutRequest, getUserRolloutSuccess } from '../reducers/addUser';

const API = `${API_LINK}api/getUsersByRollout`;

function* userRolloutAxios() {
  const state = yield select(fullState => fullState);
 

  const rollout_id = state.userProgramsFullReducer.selectedRollout;
  const {  user: { userId }, token } = state.loginReducer;

  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}?rollout_id=${rollout_id}&coach_id=${userId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* workerUserRolloutSaga() {
  try {
    console.log('GO NO GO 2')
    const response = yield call(userRolloutAxios);

    const responseFromUserRollout = response.data;
    yield put(getUserRolloutSuccess(responseFromUserRollout));

    if (response.status === 500) {
      yield put(getUserRolloutFailure(response));
    }
  } catch (error) {
    console.log('GO NO GO 3', error)
    yield put(getUserRolloutFailure(error.response));
  }
}

export function* watcherUserRolloutSaga() {
  
  yield takeLatest(getUserRolloutRequest().type, workerUserRolloutSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/get_rollout_users.js